import { render, staticRenderFns } from "./BarGraphWidget.vue?vue&type=template&id=53c96551&"
import script from "./BarGraphWidget.vue?vue&type=script&lang=js&"
export * from "./BarGraphWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c96551')) {
      api.createRecord('53c96551', component.options)
    } else {
      api.reload('53c96551', component.options)
    }
    module.hot.accept("./BarGraphWidget.vue?vue&type=template&id=53c96551&", function () {
      api.rerender('53c96551', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchpointInfo/BarGraphWidget.vue"
export default component.exports